import React, {
    createContext,
    useContext,
    useState,
    ReactNode,
    useEffect,
  } from "react";
import { GetRegionsList } from "../API/endpoints/Regions";
  
  // Define structure for Service Scope
  export interface ServiceScopeData {
    healthSupplements: string[];
    beautyAndSkin: string[];
    foodAndBeverages: string[];
    petNutrition: string[];
    keyChannelCoverage: string[];
    keyCapabilities: string[];
    warehousing: string[];
    acceptedBusinessModels: string[];
    tradingTerms: string[];
    minimumExclusivityTenure: string[];
    preferenceonMarketingInvestment: string[];
    paymentTerms: string[];
  }
  
  // Market with attached scope
  export interface MarketWithScope {
    id: string;
    name: string;
    serviceScope: ServiceScopeData;
  }
  
  // Context shape
  interface BrandsOnboardingContextType {
    selectedMarkets: MarketWithScope[];
    setSelectedMarkets: React.Dispatch<React.SetStateAction<MarketWithScope[]>>;
    updateMarketData: (
      marketID: string,
      marketName: string,
      newScope: Partial<ServiceScopeData>
    ) => void;
    localMarkets: any[]; 
  setLocalMarkets: React.Dispatch<React.SetStateAction<any[]>>; 
  customOptionsMap: Record<string, string[]>; // key = field ID, value = custom options
  setCustomOptionsMap: React.Dispatch<React.SetStateAction<Record<string, string[]>>>;

  }

  
  // Default blank service scope
  const defaultServiceScope: ServiceScopeData = {
    healthSupplements: [],
    beautyAndSkin: [],
    foodAndBeverages: [],
    petNutrition: [],
    keyChannelCoverage: [],
    keyCapabilities: [],
    warehousing: [],
    acceptedBusinessModels: [],
    tradingTerms: [],
    minimumExclusivityTenure: [],
    preferenceonMarketingInvestment: [],
    paymentTerms: [],
  };
  
  // Create context
  const BrandsOnboardingContext = createContext<BrandsOnboardingContextType | undefined>(undefined);
  
  // Provider
  export const BrandsOnboardingProvider = ({ children }: { children: ReactNode }) => {
    const [selectedMarkets, setSelectedMarkets] = useState<MarketWithScope[]>([]);
  const [allMarkets, setAllMarkets] = useState<any[]>([]);
  const [localMarkets, setLocalMarkets] = React.useState<any[]>([]);
  const [customOptionsMap, setCustomOptionsMap] = useState<Record<string, string[]>>({});

       useEffect(() => {
          (async () => {
            try {
              const response = await GetRegionsList();
              setAllMarkets(response.data);
            } catch (error) {}
          })();
        }, []);
    // Updates serviceScope of a specific market
    const updateMarketData = (
      marketID: string,
      marketName: string,
      newScope: Partial<ServiceScopeData>
    ) => {
      setSelectedMarkets((prev) =>
        prev.map((market) =>
          market.name === marketName
            ? {
                ...market,
                serviceScope: {
                  ...market.serviceScope,
                  ...newScope,
                },
              }
            : market
        )
      );
    };
  
    return (
      <BrandsOnboardingContext.Provider
        value={{
          selectedMarkets,
          setSelectedMarkets,
          updateMarketData,
          localMarkets,
          setLocalMarkets,customOptionsMap,
          setCustomOptionsMap
        }}
      >
        {children}
      </BrandsOnboardingContext.Provider>
    );
  };
  
  // Hook
  export const useBrandsOnboarding = () => {
    const context = useContext(BrandsOnboardingContext);
    if (!context) {
      throw new Error("useBrandsOnboarding must be used within a BrandsOnboardingProvider");
    }
    return context;
  };
  